import { Star } from "lucide-react";

interface SpecialHandlingIndicatorProps {
  /** @deprecated Use highValue instead */
  size?: string;
  highValue?: boolean;
  className?: string;
}

export const SpecialHandlingIndicator = ({ size, highValue, className }: SpecialHandlingIndicatorProps) => {
  // Support both legacy (size === "special_handling") and new (highValue) prop
  const show = highValue || size === "special_handling";
  if (!show) return null;
  return (
    <Star
      className={className || "w-3.5 h-3.5 text-purple-500 fill-purple-500 flex-shrink-0"}
      aria-label="High-value item"
    />
  );
};
